import { render, staticRenderFns } from "./NuevoPlan.vue?vue&type=template&id=229e3bb6"
import script from "./NuevoPlan.vue?vue&type=script&lang=js"
export * from "./NuevoPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports